import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { environment } from './environments/environment';

import { AppModule } from './app/app.module';

if (environment.production) {
  enableProdMode();
}

const tenantParam = '__tenant';
const tenantLoginKey = 'login_tenant';

function hasStoredValidAccessToken() {
  const accessToken = localStorage.getItem('access_token');
  const expiresAt = Number(localStorage.getItem('expires_at'));

  return Boolean(accessToken) && Number.isFinite(expiresAt) && expiresAt > Date.now();
}

function isLocalHost(hostname: string): boolean {
  return hostname === 'localhost' || hostname === '127.0.0.1';
}

function isHostAdminDomain(hostname: string): boolean {
  const hostDomain = (environment as any).hostDomain?.toLowerCase();
  return !!hostDomain && hostname.toLowerCase() === hostDomain;
}

function clearTenantState() {
  localStorage.removeItem(tenantParam);
  localStorage.removeItem('tenantId');
  localStorage.removeItem('tenant_logo');
  localStorage.removeItem('tenant_disableDashboard');
  localStorage.removeItem('tenant_AppName');
  localStorage.removeItem('tenant_disableMobile');
  sessionStorage.removeItem(tenantLoginKey);
}

function syncTenantAppName() {
  const tenantName = localStorage.getItem(tenantParam);

  if (tenantName && localStorage.getItem('tenant_AppName') !== tenantName) {
    localStorage.setItem('tenant_AppName', tenantName);
  }
}

function normalizeEntryUrl() {
  const url = new URL(window.location.href);
  const hostname = url.hostname.toLowerCase();
  const isRoot = url.pathname === '/';
  const isLoginPage = url.pathname === '/account/login';

  const tenantFromQuery = isLocalHost(hostname) ? url.searchParams.get(tenantParam) : null;
  const storedTenant = localStorage.getItem(tenantParam);
  const storedTenantId = localStorage.getItem('tenantId');

  if (tenantFromQuery) {
    localStorage.setItem(tenantParam, tenantFromQuery);
    sessionStorage.setItem(tenantLoginKey, tenantFromQuery);
  } else if (isRoot || isLoginPage) {
    // Clear only when there is no existing tenant context at all
    if ((isLocalHost(hostname) || isHostAdminDomain(hostname)) && !storedTenant && !storedTenantId) {
      clearTenantState();
    }
  }

  syncTenantAppName();

  if (!isRoot) {
    return;
  }

  if (hasStoredValidAccessToken()) {
    return;
  }

  const effectiveTenant = tenantFromQuery || storedTenant;

  const nextUrl =
    isLocalHost(hostname) && effectiveTenant
      ? `/account/login?${tenantParam}=${encodeURIComponent(effectiveTenant)}`
      : '/account/login';

  window.location.replace(nextUrl);
}

normalizeEntryUrl();

platformBrowserDynamic().bootstrapModule(AppModule).catch(err => console.log(err));
